export const regFIO = /^[А-ЯЁ][а-яё]*([-—–− ][А-ЯЁ][а-яё]*)*$/
export const regMail = /^[^@]+@[^@.]+\.[^@]+$/
